import { ListEntity } from "models/list-entity";
import { ListUser } from "models/list-user";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { adminDoGetListEntities } from "services/admin/list-entity";
import { adminDoGetListUsers } from "services/admin/list-user";
import { useList } from "stores/hooks/list";
import UsersTable from "./users-table";
import Block from "components/layout/block";
import Button from "components/button";
import ArchivedUsersModal from "./archived-users-modal";
import { faArrowUpRightFromSquare } from "components/icon-library";
import { StyledBlock } from "./users-table.styles";

const UsersTab: FunctionComponent = () => {
  const [users, toggleUsers] = useState<ListUser[]>([]);
  const [listEntities, toggleListEntities] = useState<ListEntity[]>([]);
  const [showArchived, toggleShowArchived] = useState(false);
  const list = useList();

  const updateUsers = async () => {
    if (list) {
      const users = await adminDoGetListUsers(list);
      toggleUsers(users);
    }
  };

  const updateEntities = async () => {
    if (list) {
      const entities = await adminDoGetListEntities(list);
      toggleListEntities(entities);
    }
  };

  useEffect(() => {
    updateUsers();
    updateEntities();
  }, [list?.uuid]);

  if (!list) {
    return null;
  }

  // NOTE: no title to keep the view more compact
  return (
    <Fragment>
      <Block>
        <UsersTable
          users={users}
          listEntities={listEntities}
          onUpdate={updateUsers}
        />
      </Block>
      <StyledBlock>
        <Button
          type="primary"
          onClick={() => toggleShowArchived(true)}
          postIcon={faArrowUpRightFromSquare}
        >
          Näytä tehtävänsä päättäneet
        </Button>
      </StyledBlock>
      {showArchived && (
        <ArchivedUsersModal
          list={list}
          onSubmit={() => updateUsers()}
          onClose={async () => toggleShowArchived(false)}
        />
      )}
    </Fragment>
  );
};

export default UsersTab;
